import { Injectable } from "@angular/core"
import { Actions, createEffect, ofType } from "@ngrx/effects"
import { catchError, map, of, switchMap, withLatestFrom } from "rxjs"
import * as NotificationsDataActions from './actions'
import { DashboardService } from "src/app/core/dashboard/dashboard.service"
import { AppStateInterface } from "../types"
import { Store } from "@ngrx/store"
import { successNotificationsDataSelector } from "./selectors"



@Injectable()
export class NotificationsEffect {

  getNotificationsData$ = createEffect(()=>
    this.actions$.pipe(
      ofType(NotificationsDataActions.getNotificationsData),
      withLatestFrom(this._store.select(successNotificationsDataSelector)),
      switchMap(([ action, notificationDataSuccess ]) => {
        if(notificationDataSuccess?.notifications && !action.forceReload){
          return of(NotificationsDataActions.getNotificationsDataSuccessAlreadyLoaded(notificationDataSuccess))
        }
        return this.dashboardService.getNotifications(action.pageNumber, action.countPerPage).pipe(
          map(NotificationsData =>  {
            return NotificationsDataActions.getNotificationsDataSuccess(NotificationsData)}
          ),
        );
      }),
    ),
  );

  getBookmarkedNotificationsData$ = createEffect(()=>
    this.actions$.pipe(
      ofType(NotificationsDataActions.getBookmarkedNotificationsData),
      switchMap((action) => {
        return this.dashboardService.getBookamrkedNotifications(action.pageNumber).pipe(
          map(NotificationsData =>  {
            return NotificationsDataActions.getBookmarkedNotificationsDataSuccess(NotificationsData)}
          ),
          catchError((error) => of(NotificationsDataActions.getNotificationsDataFailure(error))))
      })
    )
  )


  constructor(private actions$: Actions,
    private dashboardService: DashboardService,
    private _store: Store<AppStateInterface>,
  ) {}
}
